import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const navItems = [
  { to: '/', label: 'Dashboard', icon: '🏠' },
  { to: '/send', label: 'Send Message', icon: '📤' },
  { to: '/history', label: 'History', icon: '📜' },
  { to: '/campaigns', label: 'Campaigns', icon: '📋' },
];

export default function Sidebar() {
  const { user, doLogout } = useAuth(); // ✅ use doLogout, not logout

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">WA Console</div>

      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) => 'sidebar-link' + (isActive ? ' active' : '')}
          >
            <span className="sidebar-icon">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="avatar">
            {user?.name?.[0]?.toUpperCase() || 'U'}
          </div>
          <div>
            <div className="user-name">{user?.name || 'User'}</div>
            <div className="user-email">{user?.email || 'No email'}</div>
          </div>
        </div>
       <button 
        className="btn-logout" 
        onClick={() => {
          if (window.confirm('Are you sure you want to log out?')) {
            doLogout();
          }
        }}
      >
        Log out
      </button>
      </div>
    </aside>
  );
}